
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRoll as ObiRollElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-roll.js';
 
 
 

 
 export const ObiRoll = createComponent({
   react: React,
   tagName: 'obi-roll',
   elementClass: ObiRollElement,
   events: {
     
   }
  });
 
 